import { render, staticRenderFns } from "./CardTabs.yaml?vue&type=template&id=440e4098&component"
import script from "./CardTabs.yaml?vue&type=script&lang=ts&component"
export * from "./CardTabs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports